const facets = {
    closeFacetOverlay() {
        $('.facet__overlay--visible').removeClass('facet__overlay--visible');
    },
    bindHandler() {
        $(document.body).on('click', '.js-open-facet-overlay', (evt) => {
            let self = evt.currentTarget;
            $(self.dataset.target).addClass('facet__overlay--visible');
        });

        $(document.body).on('click', '.js-close-facet-overlay', () => {
            this.closeFacetOverlay();
            $('#facet__product-count').hide();
            $('#mfacet-priceSlider').removeClass('mfacet__sub--move-down');
        });
    }
};

$(() => {
    if ($('#product-grid-page').length) {
        facets.bindHandler();
    }
});

export default facets;
